import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	workItemLabel: {
		id: 'work-item.label',
		defaultMessage: 'Work item',
		description: 'Work item label',
	},
	taskLabel: {
		id: 'work-item-task.label',
		defaultMessage: 'Task',
		description: 'Task label',
	},
	epicLabel: {
		id: 'work-item-task.epic',
		defaultMessage: 'Epic',
		description: 'Epic label',
	},
	bugLabel: {
		id: 'work-item-task.bug',
		defaultMessage: 'Bug',
		description: 'Bug label',
	},
	storyLabel: {
		id: 'work-item-task.story',
		defaultMessage: 'Story',
		description: 'Story label',
	},
	milestoneLabel: {
		id: 'work-item-task.milestone',
		defaultMessage: 'Milestone',
		description: 'Milestone label',
	},
	sectionLabel: {
		id: 'work-item-task.section',
		defaultMessage: 'Section',
		description: 'Section label',
	},
	approvalLabel: {
		id: 'work-item-task.approval',
		defaultMessage: 'Approval',
		description: 'Approval label',
	},
	problemLabel: {
		id: 'work-item-task.problem',
		defaultMessage: 'Problem',
		description: 'Problem label',
	},
	incidentLabel: {
		id: 'work-item-task.incident',
		defaultMessage: 'Incident',
		description: 'Incident label',
	},
	questionLabel: {
		id: 'work-item-task.question',
		defaultMessage: 'Question',
		description: 'Question label',
	},
	issueLabel: {
		id: 'work-item-task.issue',
		defaultMessage: 'Issue',
		description: 'Issue label',
	},
	for: {
		id: 'work-item-status.for',
		defaultMessage: '{statusLozenge} for {dateLozenge}',
		description: 'The conjunction between a status and date e.g. "On track for August"',
	},
	isAssigned: {
		id: 'work-item-assignee.assigned',
		defaultMessage:
			'{isAssigned, select, internal {{firstName} is assigned} other {External person is assigned}}',
		description: 'Text that goes after assignee name',
	},
	created: {
		id: 'work-item-creator.created',
		defaultMessage:
			'{created, select, internal {{firstName} created} other {External person created}}',
		description: 'Text that goes after creator name',
	},
});
